import { IconButton, IconButtonType } from "@whitespace/whitespace-ui";
import React from "react";

import "./ContinueConfirmation.scss";
import { Modal } from "react-bootstrap";
import { IContinueConfirmation } from "interfaces/components/IContinueConfirmation";

export const ContinueConfirmation: React.FC<IContinueConfirmation> = ({
  title,
  item,
  okLabel,
  children,
  onContinue,
  onCancel,
  ...props
}) => {
  const className = `continue-confirmation ${props.className || ""}`;
  return (
    <Modal
      {...props}
      centered
      restoreFocus={false}
      className={className}
      aria-labelledby="continue-confirmation-title"
    >
      <Modal.Header closeButton>
        <Modal.Title data-testid="continueConfirmationTitle" id="continue-confirmation-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <IconButton
          data-testid="continueConfirmationBtnSave"
          iconType={IconButtonType.Save}
          variant="primary"
          onClick={onContinue}
        >
          {okLabel ?? "Ok"}
        </IconButton>
        <IconButton
          data-testid="continueConfirmationBtnCancel"
          iconType={IconButtonType.Cancel}
          variant="secondary"
          onClick={onCancel}
        >
          Cancel
        </IconButton>
      </Modal.Footer>
    </Modal>
  );
};
